import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setFilter} from "../actions/filter_actions";

export default function FilterAttributes(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({setFilter}, dispatch);
}

function mapStateToProps(state) {
    return {
        filterStatus:state.filterAttribute.status,
        startDate:state.filterAttribute.startDate,
        endDate:state.filterAttribute.endDate,
        inspectionIds:state.filterAttribute.inspectionIds
    };
}



// WEBPACK FOOTER //
// ./src/containers/filter_container.js